export const detailsSelectors = {
  item: (state) => state.item,
  update: (state) => state.update,
}
